
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

import FormInput from '@/components/controls/form-input.vue';
import SelectInput from '@/components/controls/select-input.vue';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import Publish from '@/components/forms/publish.vue';

import { DistributorsActions } from '@/store/modules/distributors/types';
import Distributor, { DistributorStatus, DistributorUserRow } from '@/store/modules/distributors/distributor';

export default Vue.extend({
  name: 'EditDistributorView',
  inject: {
    $validator: '$validator',
  },
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    FormInput,
    SelectInput,
    NotificationBanner,
    Publish,
  },
  props: {
    add: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('distributors', {
      distributor: 'editableDistributor',
      editableStatus: 'editableStatus',
    }),
    ...mapGetters('distributors', {
      isLoading: 'editableIsLoading',
      isSaving: 'editableIsSaving',
      hasUnsavedChanges: 'editableHasUnsavedChanges',
    }),
    isInactive() {
      return this.distributor && this.distributor.status === DistributorStatus.Inactive;
    },
    distributorUsers(): DistributorUserRow[] {
      const d = this.distributor as Distributor | undefined;
      return d && Array.isArray(d.users) ? d.users : [];
    },
  },
  methods: {
    ...mapActions('distributors', {
      updateDistributor: DistributorsActions.UPDATE_EDITABLE,
      save: DistributorsActions.SAVE_EDITABLE,
      removeDistributor: DistributorsActions.DELETE,
      restoreDistributor: DistributorsActions.RESTORE,
    }),
    remove() {
      this.removeDistributor({ id: this.distributor!.id });
    },
    restore() {
      this.restoreDistributor({ id: this.distributor!.id });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      const answer = window.confirm(this.$t('Do you really want to leave? You have unsaved changes!'));

      if (!answer) {
        next(false);
        return;
      }
    }

    next();
  },
});
